(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["noble-merchandising-box"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('noble-merch-card')) {
    customElements.define('noble-merch-card', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.addEventListener('change', event => {
          if (!event.target.matches('[data-merch-select]')) return;
          event.stopPropagation();
          const data = event.target.selectedOptions[0].dataset;
          this.querySelector('[data-merch-price]').textContent = data.price;
          this.querySelector('[data-merch-retail]').textContent = data.retail;
          this.querySelector('[data-merch-comparison]').hidden = data.compare !== 'true';
          this.querySelectorAll('[data-merch-link]').forEach(link => link.href = data.url);
          const image = this.querySelector('.noble-merch__image img');
          if (image && data.image) { image.removeAttribute('srcset'); image.src = data.image; }
          const available = data.available === 'true';
          const add = this.querySelector('[data-merch-add]');
          if (add) { add.disabled = !available; add.textContent = available ? add.dataset.addLabel : add.dataset.soldLabel; }
          const shop = this.querySelector('[data-merch-shop]');
          if (shop) { shop.hidden = !available; this.querySelector('[data-merch-unavailable]').hidden = available; }
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
